<div *ngIf="debug" style="position:absolute;top:0;width:270px;background:rgba(255,255,255,0.3);color:black;z-index:99999;">
  <p>Accuracy Information</p>
  <ul>
    <li>Current time: {{player.currentTime}}</li>
    <li>Current frame: {{currentFrame}}</li>
  </ul>
</div>
